var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTikTok = function SvgTikTok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M15 6.667h3.333c0 1.675 2.452 3.333 3.334 3.333v3.333c-1.009 0-2.22-.443-3.334-1.19v6.19c0 2.757-2.243 5-5 5-2.756 0-5-2.243-5-5 0-2.756 2.244-5 5-5v3.334a1.667 1.667 0 0 0 0 3.333c.92 0 1.667-.748 1.667-1.667zM5 0C2.258 0 0 2.258 0 5v20c0 2.742 2.258 5 5 5h20c2.742 0 5-2.258 5-5V5c0-2.742-2.258-5-5-5z",
    opacity: 0.704
  })));
};
export default SvgTikTok;